import * as actionTypes from "./actionTypes";
import axios from "../../service/AxoisOrder/AxoisOrder";
import {
  ErrorToast,
  InfoToast,
  SuccessToast,
} from "../../hoc/ToastNotify/ToastNotify";
import { client } from "../../service/ApolloClient/ApolloClient";
import errorValidationApollo from "../../utility/Forms/errorValidationApollo";
import {
  MUTATION_CELLPHONE_VERIFIED,
  MUTATION_CELLPHONE_VERIFY_SEND,
  MUTATION_LOGIN,
  MUTATION_LOGOUT,
} from "../../service/ApolloClient/ApolloMutation";
import {
  setCookie,
  setTokenCookie,
} from "../../utility/Cookie/CookiesFunction";

export const authReloadCategory = (reload) => {
  return {
    type: actionTypes.AUTH_RELOAD_CATEGORY,
    reload: reload,
  };
};

export const authSetServer = (token) => {
  return {
    type: actionTypes.AUTH_SET_SERVER,
    token: token,
  };
};

export const authStart = () => {
  return {
    type: actionTypes.AUTH_START,
  };
};

export const authSuccess = (token, userId, userDetail) => {
  return {
    type: actionTypes.AUTH_SUCCESS,
    token: token,
    userId: userId,
    user: userDetail,
  };
};

export const authErrorRemoved = (name) => {
  return {
    type: actionTypes.AUTH_ERROR_REMOVE,
    name: name,
  };
};

export const authFail = (errors, errorJson) => {
  return {
    type: actionTypes.AUTH_FAIL,
    errors: errors,
    errorJson: errorJson,
  };
};

export const authLoad = () => {
  return {
    type: actionTypes.AUTH_LOAD,
    errors: null,
    errorJson: null,
  };
};

export const authCountNotif = (count) => {
  return {
    type: actionTypes.AUTH_NOTIF_COUNT,
    count: count,
  };
};

export const authGetCountNotif = () => {
  return (dispatch, getState) => {
    // client
    //     .query({
    //         query: QUERY_NOTIFICATIONS_COUNT,
    //         fetchPolicy: 'no-cache',
    //     })
    //     .then(result => {
    //             let countNotif = result.data.notificationsNewCount;
    //             return dispatch(authCountNotif(countNotif));
    //         }
    //     )
    //     .catch(reason => {
    //
    //         return dispatch(authFail(errorValidationApollo(reason), null))
    //     });
  };
};

export const authGetUser = (notif = true) => {
  return (dispatch, getState) => {
    // setTimeout(function () {
    //     client
    //         .query({
    //             query: QUERY_ME,
    //             fetchPolicy: 'no-cache',
    //         })
    //         .then(result => {
    //                 let user = result.data.user;
    //                 if (user === null) {
    //                     return dispatch(authFail({"password": "کلمه عبور صحیح نمی باشد"}, null))
    //                 } else {
    //                     dispatch(authSuccess(getState().auth.token, user.id, user));
    //
    //                     if (notif)
    //                         SuccessToast("با موفقیت وارد شدید.");
    //
    //                     return dispatch(registerCLEAR())
    //
    //                 }
    //             }
    //         )
    //         .catch(reason => {
    //
    //             return dispatch(authFail(errorValidationApollo(reason), null))
    //         });
    // }, 1000)
  };
};

export const auth = (cellphone, password) => {
  return (dispatch) => {
    dispatch(authStart());

    client
      .mutate({
        mutation: MUTATION_LOGIN,
        variables: { cellphone: cellphone, password: password },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        let token = result.data.login;
        setTokenCookie(token);

        if (token === null) {
          ErrorToast("اطلاعات وارد شده صحیح نمی باشد");
          return dispatch(
            authFail({ password: "کلمه عبور صحیح نمی باشد" }, null),
          );
        } else {
          localStorage.setItem("token", token);
          dispatch(authSuccess(token, null, null));
          dispatch(authGetUser());
          dispatch(authModal());

          axios.defaults.headers.common["Authorization"] =
            "Bearer " + localStorage.getItem("token");
        }
      })
      .catch((reason) => {
        if (reason.graphQLErrors) {
          return dispatch(authFail(errorValidationApollo(reason), null));
        } else {
          ErrorToast(reason);
          return dispatch(authFail(reason, null));
        }
      });
  };
};

export const authLogout = () => {
  client
    .mutate({ mutation: MUTATION_LOGOUT })
    .then((res) => {
      localStorage.setItem("token", null);
      client.resetStore();
      setCookie("token", "");
      SuccessToast("با موفقیت از سیستم خارج شدید");
    })
    .catch((err) => {
      ErrorToast("مشکل در خروج");
    });

  return {
    type: actionTypes.AUTH_LOGOUT,
  };
};

export const authVerifySendLoad = (loading, errors) => {
  return {
    type: actionTypes.AUTH_VERIFYSEND_LOAD,
    errors: errors,
    loading: loading,
  };
};

export const authVerificationLoad = (loading, errors) => {
  return {
    type: actionTypes.AUTH_VERIFICATION_LOAD,
    errors: errors,
    loading: loading,
  };
};

export const authCellphoneVerify = (cellphone, cellphone_code) => {
  return (dispatch) => {
    dispatch(authVerificationLoad(true, null));

    client
      .mutate({
        mutation: MUTATION_CELLPHONE_VERIFIED,
        variables: { cellphone: cellphone, cellphone_code: cellphone_code },
      })
      .then((result) => {
        let token = result.data.cellphoneVerified;
        localStorage.setItem("token", token);
        InfoToast("کد صحیح بود در حال وارد شدن");
        dispatch(authSuccess(token, null, null));
        dispatch(authGetUser());
        dispatch(authModal());
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + localStorage.getItem("token");

        return dispatch(authVerificationLoad(false, null));
      })
      .catch((reason) => {
        dispatch(authFail(errorValidationApollo(reason), null));
        return dispatch(
          authVerificationLoad(false, errorValidationApollo(reason)),
        );
      });
  };
};

export const authCellphoneVerifySend = (cellphone) => {
  return (dispatch) => {
    dispatch(authVerifySendLoad(true, null));

    client
      .mutate({
        mutation: MUTATION_CELLPHONE_VERIFY_SEND,
        variables: { cellphone: cellphone },
      })
      .then((result) => {
        let VerifySendStatus = result.data.cellphoneVerifySend;

        if (VerifySendStatus === "true") {
          SuccessToast("کد مجدد ارسال شد");
          dispatch(authVerifySendLoad(false, null));
        } else {
          ErrorToast(VerifySendStatus);
          dispatch(authVerifySendLoad(false, VerifySendStatus));
        }
      })
      .catch((reason) => {
        ErrorToast(errorValidationApollo(reason).cellphone);
        return dispatch(
          authVerifySendLoad(false, errorValidationApollo(reason)),
        );
      });
  };
};

export const authModal = (
  openLogin = false,
  openRegister = false,
  openCellphoneVerification = false,
) => {
  return {
    type: actionTypes.AUTH_MODAL_STATUS,
    openLogin: openLogin,
    openRegister: openRegister,
    openCellphoneVerification: openCellphoneVerification,
  };
};
